<template>
	<el-row>
		<el-col :span="24" style="text-align: left;">
			<div class="base-form">
				<h2>
					Авторизация
				</h2>
			</div>
		</el-col>			
	</el-row>
	<div class="outer">
		<div class="middle">
			<div class="inner">
				<el-icon size="68" style="color: var(--el-color-primary)"><Lock /></el-icon>
				<el-form ref="authForm" class="base-form" :rules="rules" :model="ruleForm">
					<el-form-item label="Логин" label-position="top" prop="login">
						<el-input v-model="ruleForm.login" />
					</el-form-item>

					<el-form-item label="Пароль" label-position="top" prop="passw">
						<el-input v-model="ruleForm.passw" show-password type="password" />
					</el-form-item>

					<el-form-item>
						<div style="margin: .8rem 0">
							<button-loading-component :loading="signInOperationPending" label="Войти" @onClick="signIn" />						
						</div>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { ElForm, FormInstance, ElNotification } from 'element-plus';
import { Lock } from '@element-plus/icons-vue';
import { reactive } from 'vue';
import store from '@/store';
import router from '@/router';
import ButtonLoadingComponent from '@/components/ButtonLoadingComponent.vue';

@Options({
	components: {
		ElForm, ButtonLoadingComponent, Lock
	},
})
export default class SignInView extends Vue {

	/** view-models */
	signInOperationPending = false;

	rules = reactive({
		login: [			
			{ required: true, message: 'Логин не может быть пустым'},
			{ min: 3, max: 255, message: 'Логин не может быть короче 2 и длинее 255 символов'}			
		],
		passw: [			
			{ required: true, message: 'Пароль не может быть пуст'},			
			{ min: 4, max: 255, message: 'Пароль не может быть короче 4 и длинее 255 символов'}		
		]
	});

	ruleForm = reactive({
		login: '',
		passw: ''
	});

	async signIn() {
		const form = this.$refs.authForm as FormInstance;
		form.validate(async (valid) => {
			if (valid) {		
				this.signInOperationPending = true;
				try {
					const isAuthenticated = await store.dispatch('authenticateAsync', { login: this.ruleForm.login, passw: this.ruleForm.passw });

					if (isAuthenticated === null) {
						ElNotification({
							message: `Внутренняя ошибка авторизации`,
							type: 'error'
						});
					} else if (isAuthenticated === false) {					
						this.ruleForm.passw = '';
						ElNotification({
							message: `Ошибка, пользователь не найден`,
							type: 'error'
						});
						this.signInOperationPending = false;
					} else {					
						await store.dispatch('getRefreshTokenWithJwtAsync');

						ElNotification({
							message: `Вы вошли в систему как ${store.getters.user.login}`,
							type: 'success',
						});

						router.push('/');
						this.signInOperationPending = false;
					}				
				} catch(e) {					
					ElNotification({
						message: `Внутренняя ошибка авторизации`,
						type: 'error'
					});
					console.error('SignIn error', e);
				}
			}
		});
	}
}
</script>

<style scoped>
	.outer {
		display: table;
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
	}

	.middle {
		display: table-cell;
		vertical-align: middle;
	}

	.inner {
		margin-left: auto;
		margin-right: auto;
		width: 400px;
	}
</style>